import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import SpeczeLogo from '../../assets/SpeczeLogo'
import { Alert } from '../../components/ui'
import toast from 'react-hot-toast'

export default function Register() {
  const [form, setForm] = useState({ name: '', email: '', password: '', password_confirmation: '' })
  const [errors, setErrors] = useState({})
  const [apiError, setApiError] = useState('')
  const [loading, setLoading]   = useState(false)
  const { register } = useAuth()
  const navigate     = useNavigate()

  const set = k => e => setForm(f => ({ ...f, [k]: e.target.value }))

  const handleSubmit = async e => {
    e.preventDefault()
    setErrors({})
    setApiError('')
    setLoading(true)
    try {
      await register(form)
      toast.success('Account created! Welcome to Specze 🚀')
      navigate('/dashboard')
    } catch (err) {
      const apiErrs = err.response?.data?.errors
      if (apiErrs) setErrors(Object.fromEntries(Object.entries(apiErrs).map(([k,v]) => [k, v[0]])))
      else setApiError(err.response?.data?.message || 'Registration failed. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center relative overflow-hidden"
      style={{ background: 'linear-gradient(160deg, #07020f 0%, #180a3a 40%, #0d1a5c 70%, #07020f 100%)' }}>
      <div className="absolute inset-0 stars-bg opacity-60" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] rounded-full blur-3xl pointer-events-none bg-purple-600/15" />

      <div className="relative z-10 w-full max-w-[440px] mx-auto px-6 py-12">
        <div className="text-center mb-8">
          <div className="flex justify-center mb-5"><SpeczeLogo size={44} /></div>
          <h1 className="font-display font-bold text-2xl text-white">Create your account</h1>
          <p className="text-white/40 text-sm mt-1">Start generating docs in minutes — free forever</p>
        </div>

        <div className="glass-card p-7">
          {apiError && <div className="mb-5"><Alert type="error">{apiError}</Alert></div>}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="label-specze">Full name</label>
              <input className={`input-specze ${errors.name ? 'input-error' : ''}`}
                type="text" required autoFocus value={form.name} onChange={set('name')} placeholder="Jane Smith" />
              {errors.name && <p className="text-[11px] text-red-400 mt-1.5">{errors.name}</p>}
            </div>
            <div>
              <label className="label-specze">Email address</label>
              <input className={`input-specze ${errors.email ? 'input-error' : ''}`}
                type="email" required value={form.email} onChange={set('email')} placeholder="jane@company.com" />
              {errors.email && <p className="text-[11px] text-red-400 mt-1.5">{errors.email}</p>}
            </div>
            <div>
              <label className="label-specze">Password</label>
              <input className={`input-specze ${errors.password ? 'input-error' : ''}`}
                type="password" required value={form.password} onChange={set('password')} placeholder="Min. 8 characters" />
              {errors.password && <p className="text-[11px] text-red-400 mt-1.5">{errors.password}</p>}
            </div>
            <div>
              <label className="label-specze">Confirm password</label>
              <input className={`input-specze ${errors.password_confirmation ? 'input-error' : ''}`}
                type="password" required value={form.password_confirmation}
                onChange={set('password_confirmation')} placeholder="Repeat password" />
            </div>

            <p className="text-[11px] text-white/30 leading-relaxed">
              By creating an account you agree to our{' '}
              <a href="#" className="text-purple-400 hover:text-purple-300">Terms of Service</a> and{' '}
              <a href="#" className="text-purple-400 hover:text-purple-300">Privacy Policy</a>.
            </p>

            <button type="submit" disabled={loading} className="btn-specze w-full py-3 text-white"
              style={{ background: 'linear-gradient(135deg, #7c3aed, #a855f7)', boxShadow: '0 0 20px rgba(139,63,255,0.4)' }}>
              {loading
                ? <><span className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />Creating account…</>
                : 'Create Free Account'}
            </button>
          </form>
        </div>

        <p className="text-center text-sm text-white/40 mt-6">
          Already have an account?{' '}
          <Link to="/login" className="text-purple-400 hover:text-purple-300 font-semibold transition-colors">Sign in</Link>
        </p>
      </div>
    </div>
  )
}
